import BetsSettingsPartContainer from "@baseUI/component/settings/BetsSettingsPartContainer";

export default class BetsSettingsPartContainerPortrait extends BetsSettingsPartContainer {

    constructor(params) {
        super(params)
    }

    setParametersSizePosition(params){
        this.param = {
            panelPopupPosition: {x: 0, y: 0},
            betsCaptionPosition: params.captionPosition,
            lineCaption: {x1: 30, y1: 100, x2: 930, y2: 100 },
            countRow: 4,
            settingsBtn: {width: 220, height: 130, spaceX: 40, spaceY: 50, startX: 100, startY: 230},
        }
    }


}
